import { useAppDispatch } from 'app/hooks';
import {
  setSystemIsQuoted,
  updateSelectedDuctedSystem,
  updateSelectedSystem
} from 'features/systems';
import { useIsSystemQuoted } from 'hooks/use-quoted-unique-ids';
import { useCallback } from 'react';

export function useUnquoteOnAccessoryChange() {
  const dispatch = useAppDispatch();
  const isSystemQuoted = useIsSystemQuoted();

  const unquoteDuctless = useCallback(
    (system?: { uniqueId: string; quoteStatus?: string }) => {
      if (!system || !isSystemQuoted(system)) return;
      dispatch(
        setSystemIsQuoted({ uniqueId: system.uniqueId, isQuoted: false })
      );
      dispatch(
        updateSelectedSystem({
          uniqueId: system.uniqueId,
          quoteStatus: 'unsent'
        })
      );
    },
    [dispatch, isSystemQuoted]
  );

  const unquoteDucted = useCallback(
    (system?: { id: number; quoteStatus?: string }) => {
      if (!system || system.quoteStatus !== 'sent') return;
      dispatch(
        updateSelectedDuctedSystem({
          id: system.id,
          quoteStatus: 'unsent'
        })
      );
    },
    [dispatch]
  );

  return { unquoteDuctless, unquoteDucted };
}
